import { render, staticRenderFns } from "./AssetEdit.vue?vue&type=template&id=5ed0c87e&scoped=true&"
import script from "./AssetEdit.vue?vue&type=script&lang=js&"
export * from "./AssetEdit.vue?vue&type=script&lang=js&"
import style0 from "./AssetEdit.vue?vue&type=style&index=0&id=5ed0c87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed0c87e",
  null
  
)

export default component.exports